// SEO utility functions for dynamic Schema.org JSON-LD generation

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export const addSchemaToPage = (schema: object) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  script.setAttribute('data-schema', 'true');
  document.head.appendChild(script);
  return script;
};

export const removePageSchemas = () => {
  const schemas = document.querySelectorAll('script[data-schema="true"]');
  schemas.forEach(schema => schema.remove());
};

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "PLADUREX",
  "image": "https://public.readdy.ai/ai/img_res/5bc5f722-4c51-4a16-b952-a25cd81fdf88.png",
  "telephone": "+34629501941",
  "url": SITE_URL,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Badalona",
    "addressRegion": "Barcelona",
    "addressCountry": "ES"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "41.4502",
    "longitude": "2.2470"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Badalona"
    },
    {
      "@type": "City",
      "name": "Barcelona"
    }
  ],
  "priceRange": "€€",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "08:00",
    "closes": "19:00"
  },
  "sameAs": [
    "https://wa.me/34629501941"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "127"
  }
});

export const getServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Instalación de pladur",
  "provider": {
    "@type": "LocalBusiness",
    "name": "PLADUREX",
    "telephone": "+34629501941",
    "url": SITE_URL
  },
  "areaServed": {
    "@type": "City",
    "name": "Badalona"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de pladur en Badalona",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Tabiques de pladur",
          "description": "Divisiones interiores rápidas y limpias para redistribuir espacios"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Trasdosados",
          "description": "Revestimiento de paredes con aislamiento térmico y acústico"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Falsos techos",
          "description": "Techos continuos y registrables para mejorar estética y funcionalidad"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Aislamiento acústico",
          "description": "Soluciones de insonorización para reducir ruidos molestos"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Aislamiento térmico",
          "description": "Mejora la eficiencia energética y el confort de tu hogar"
        }
      }
    ]
  }
});

export const getBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${SITE_URL}${item.url}`
  }))
});

export const getWebPageSchema = (pageName: string, description: string, url: string) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": pageName,
  "description": description,
  "url": `${SITE_URL}${url}`,
  "inLanguage": "es-ES",
  "isPartOf": {
    "@type": "WebSite",
    "name": "PLADUREX",
    "url": SITE_URL
  }
});
